import { Button, Card, Divider, Form, Input,Radio,Typography } from 'antd';
import React, { useState,useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import api from '../../../../../apis';
import { showMessageModal,showSuccessMessageModal } from '../../../../utils';
import { useNavigate } from 'react-router-dom';
import config from '../../../../../config';
const { Title, Text } = Typography;

const recaptcha_auth = config.recaptchaSiteKey;


const Index = ({}) => {
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaToken2, setCaptchaToken2] = useState(null);
   
    const [contactMethod, setContactMethod] = useState('email');
    const [resetMethod, setResetMethod] = useState('change_password');
    const [idType, setIdType] = useState('nric');
    const [isSending, setIsSending] = useState(false);
    const [cooldown, setCooldown] = useState(0);
    const [tacChecksum, setTacChecksum] = useState('');

    const [step, setStep] = useState(1);

    const [form] = Form.useForm();
    const [form2] = Form.useForm();

    const [loaded, setLoaded] = useState(false);

    const [passwordRules, setPasswordRules] = useState<any[]>([
        { required: true, message: 'Please enter' }
    ]);
    const [passwordRulesText, setPasswordRulesText] = useState<any>(null);
    const [credentialRulesCache, setCredentialRulesCache] = useState<any>(null);

    const buildFieldRules = (r: any) => {
        const newRules: any[] = [
            { required: true, message: 'Please enter the new value' }
        ];
        const newRulesText: any[] = [];

        if (r.min && r.max) {
            newRules.push({
                pattern: new RegExp(`^.{${r.min},${r.max}}$`),
                message: `${r.min}-${r.max} characters`
            });
            newRulesText.push(<div key="len">{r.min}-{r.max} characters</div>);
        }

        if (r.alphabet) {
            if (r.sensitive) {
                newRules.push({ pattern: /[A-Z]/, message: 'At least one Alphabet (Uppercase)' });
                newRules.push({ pattern: /[a-z]/, message: 'At least one Alphabet (Lowercase)' });
                newRulesText.push(<div key="up">At least one Alphabet (Uppercase)</div>);
                newRulesText.push(<div key="low">At least one Alphabet (Lowercase)</div>);
            } else {
                newRules.push({ pattern: /[a-zA-Z]/, message: 'At least one Alphabet' });
            }
        } else if (r.alphabet === false) {
            newRules.push({ pattern: /^[^a-zA-Z]*$/, message: 'Alphabets are not allowed' });
        }

        if (r.numeric === true) {
            newRules.push({ pattern: /\d/, message: 'At least one Number' });
            newRulesText.push(<div key="num">At least one Number</div>);
        } else if (r.numeric === false) {
            newRules.push({ pattern: /^\D*$/, message: 'Numbers are not allowed' });
        }

        if (r.symbol === true) {
            newRules.push({ pattern: /[^a-zA-Z0-9\s]/, message: 'At least one Symbol' });
            newRulesText.push(<div key="sym">At least one Symbol</div>);
        } else if (r.symbol === false) {
            newRules.push({ pattern: /^[a-zA-Z0-9]*$/, message: 'Symbols are not allowed' });
        } else if (r.symbol) {
            const escapedSymbols = r.symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const symbolRegex = new RegExp(`[${escapedSymbols}]`);
            newRules.push({ pattern: symbolRegex, message: `At least one Symbol (${r.symbol})` });
            newRulesText.push(<div key="symStr">At least one Symbol ({r.symbol})</div>);
        }

        if (r.startWith === 'alphabet') {
            newRules.push({ pattern: /^[A-Za-z]/, message: 'Must start with an alphabet' });
            newRulesText.push(<div key="start-a">Must start with an alphabet</div>);
        } else if (r.startWith === 'numeric') {
            newRules.push({ pattern: /^[0-9]/, message: 'Must start with a number' });
            newRulesText.push(<div key="start-n">Must start with a number</div>);
        }

        newRules.push({ pattern: /^\S+$/, message: 'Spaces are not allowed' });

        return { newRules, newRulesText };
    };

    //for trading pin, avoid type="password" so Chrome doesn't trigger data-breach popup; mask with CSS instead
    const supportsTextSecurity =
        typeof CSS !== 'undefined' && CSS.supports('-webkit-text-security', 'disc');
    const usePinMaskedInput =
        resetMethod === 'reset_trading_pin' && supportsTextSecurity;
    const renderSecretInput = () =>
        usePinMaskedInput ? (
            <Input
                type="text"
                autoComplete="off"
                style={{ WebkitTextSecurity: 'disc' } as any}
            />
        ) : (
            <Input.Password />
        );

    useEffect(() => {
        const requestCredentialRules = async () => {
            const result = await api.userCredentialRules();
            if (!result?.rules) return;
            setCredentialRulesCache(result.rules);
        };
        requestCredentialRules();
    }, []);

    useEffect(() => {
        if (!credentialRulesCache) return;
        if (resetMethod !== 'change_password' && resetMethod !== 'reset_trading_pin') {
            return;
        }
        const isTradingPin = resetMethod === 'reset_trading_pin';
        let target = isTradingPin ? credentialRulesCache.tradepin : credentialRulesCache.password;
        if (!target) return;

        //force use numeric
        if (isTradingPin && config.traderPinForceNumeric) {
            target = { ...target, alphabet: false, numeric: true, symbol: false, sensitive: false };
        }

        const { newRules, newRulesText } = buildFieldRules(target);
        const label = isTradingPin ? 'Trading PIN' : 'Password';
        newRules[0] = { required: true, message: `Please enter` };
        setPasswordRules(newRules);
        setPasswordRulesText(
            <div style={{ marginTop: -16, marginBottom: 16 }}>
                {label} must meet ALL of the following requirements ONLY:
                {newRulesText}
            </div>
        );
        form2.validateFields(['password']).catch(() => {});
    }, [resetMethod, credentialRulesCache]);

    useEffect(() => {
        const id = 'recaptcha-enterprise';
        if (document.getElementById(id)) {
          setLoaded(true);
          return;
        }


        if(recaptcha_auth){
            const script = document.createElement('script');
            script.id = id;
            script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptcha_auth}`;
            script.async = true;
            script.defer = true;
            script.onload = () => setLoaded(true);
            document.head.appendChild(script);
        }
    
       
    
        return () => {
    
        };
      }, []);


    const handleCaptchaChange = (token) => {
      console.log("Captcha token:", token);
      setCaptchaToken(token);
      // Send this token to backend for verification
    };

    const handleCaptchaChange2 = (token) => {
        console.log("Captcha token:", token);
        setCaptchaToken2(token);
        // Send this token to backend for verification
      };

    const onFinishForm1 = (values) => {
        // if (!captchaToken) {
        //   showMessageModal('Please complete the CAPTCHA.');
        //   return;
        // }
    
        // Combine form values and captcha token here
        console.log('Form values:', values);
        handleVerifyTAC(values);
 
    };

    const onFinishForm2 = (values) => {
        // if (!captchaToken2) {
        //     showMessageModal('Please complete the CAPTCHA.');
        //     return;
        // }
      
        if(resetMethod == 'change_password' || resetMethod == 'reset_trading_pin' ){

            handleResetPassword(values);
        }else if(resetMethod == 'unblock_account'){
            handleUnblockAccount(values);
        }
    };
    

    const handleResetPassword = async (values) => {
        try {

            const executeReset = async (token: string | null | undefined) => {
              
                let param = values;
                if(resetMethod == 'change_password' ){
                    param.type = 0;
                }else if(resetMethod == 'reset_trading_pin' ){
                    param.type = 1;
                }

                //   console.log('handleResetPassword values:', param,token);


                const result = await api.resetPassword(param,token as any);
                // console.log('result:', result);

                if(result){
                    if(result.status == 0){
                      //  showSuccessMessageModal("handleVerifyTAC successful.");

                        showSuccessMessageModal("You have successfully chosen a new password");
                        navigate('/login');
                    }else{
                        showMessageModal(result.message);
                    }
                }
            };

            if(!recaptcha_auth){
                await executeReset(null);
            }else{
                window.grecaptcha.enterprise.ready(async () => {
                    const token = await window.grecaptcha.enterprise.execute(recaptcha_auth, {
                    action: 'PASSWORD_RESET',
                    });
                    await executeReset(token);
                })
            }

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    }

    const handleUnblockAccount = async (values) => {
        try {

            const executeUnblock = async (token: string | null | undefined) => {
                // console.log('handleUnblockAccount values:', values);

                const result = await api.unblockAccount({},token as any);
                console.log('result:', result);

                if(result){
                    if(result.status == 0){
                      //  showSuccessMessageModal(“handleVerifyTAC successful.”);

                        showSuccessMessageModal("Successful! Your account is unblocked. Please re-login with your existing password.");
                        navigate('/login');
                    }else{
                        showMessageModal(result.message);
                    }
                }
            };

            if(!recaptcha_auth){
                await executeUnblock(null);
            }else{
                window.grecaptcha.enterprise.ready(async () => {
                    const token = await window.grecaptcha.enterprise.execute(recaptcha_auth, {
                    action: 'PASSWORD_RESET',
                    });
                    await executeUnblock(token);
                })
            }

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    }


    const handleSendCode = async () => {
        try {
     
            const values = form.getFieldsValue();
            const fieldsToValidate = Object.keys(values).filter(key => key !== 'code');
            const validateFields = await form.validateFields(fieldsToValidate);

            console.log('handleSendCode values:', values);


            try {
                const executeSendCode = async (token: string | null | undefined) => {
                    const result = await api.requestTAC(values,token as any);
                    console.log('result:', result);

                    if(result){
                        if(result.status == 0){
                            showSuccessMessageModal("Request successful.");
                            let checksum = result.data.checksum;
                            setTacChecksum(checksum+"-");
                        }else{
                            showMessageModal(result.message);
                        }
                    }

                    // Simulate API call to send TAC
                    setIsSending(true);
                    setCooldown(30); // 60-second cooldown
                    //   message.success(`TAC sent to ${contact}`);

                    const interval = setInterval(() => {
                        setCooldown((prev) => {
                        if (prev <= 1) {
                            clearInterval(interval);
                            setIsSending(false);
                            return 0;
                        }
                        return prev - 1;
                        });
                    }, 1000);
                };

                if(!recaptcha_auth){
                    await executeSendCode(null);
                }else{
                    window.grecaptcha.enterprise.ready(async () => {
                        const token = await window.grecaptcha.enterprise.execute(recaptcha_auth, {
                        action: 'PASSWORD_RESET',
                        });
                        await executeSendCode(token);
                    })
                }
            } catch (error) {
                console.error("reCAPTCHA execution error:", error);
                // You can display a user-friendly message
                alert("verification failed. Please try again later.");
            }

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    };

    const handleVerifyTAC = async (values) => {
        try {
     
            console.log('handleVerifyTAC values:', values);

            const result = await api.verifyTAC(values);
            console.log('result:', result);
          
            if(result){
                if(result.status == 0){
                  //  showSuccessMessageModal("handleVerifyTAC successful.");

                    setStep(2);
             
                }else{
                    showMessageModal(result.message);
                }
            }

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    }
  

    return (
        <> 
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#f5f5f5', // Optional for better visibility
                    padding: 24,
                }}
            >
            <Card  style={{ maxWidth: 800, margin: '0 auto', padding: 24, borderRadius: 12,boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                
                <div className=' register-form'>
                    <Title level={4}>	
                    	
                        Reset Password / Reset Trading PIN / Unblock Account</Title>
                                                <Text type="secondary">	
                            
                                                Please complete the following data associated with your account.
                        <br/>
                        Contact your authorized Dealer's Representative if your registered Mobile or Email have changed.</Text>
                        <br />
            

                        {
                            step == 1 && 
                            (
                                <>
                                    <Form form={form} layout="vertical" style={{ marginTop: 24 }}  onFinish={onFinishForm1}>
                                        <Form.Item
                                            label="User ID"
                                            name="username"
                                            rules={[{ required: true, message: 'Please enter your User ID' }]}
                                        >
                                            <Input />
                                        </Form.Item>

                                        <Divider />

                                        {/* Contact Method Radio Group */}
                                        <Form.Item label="Contact Method">
                                            <Radio.Group
                                            value={contactMethod}
                                            onChange={(e) => {
                                                const method = e.target.value;
                                                setContactMethod(method);
                                                form.setFieldsValue({ email: '', mobile: '' }); // reset both fields
                                            }}
                                        >
                                                <Radio value="email">Email Address</Radio>
                                                <Radio value="mobile">Malaysian Mobile No</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        {/* Email Input */}
                                        {contactMethod === 'email' && (
                                            <Form.Item
                                            label="Email Address"
                                            name="email"
                                            rules={[
                                                { required: true, message: 'Please enter your email address' },
                                                { type: 'email', message: 'Please enter a valid email address' },
                                            ]}
                                            >
                                            <Input placeholder="Enter your Email Address" />
                                            </Form.Item>
                                        )}

                                        {/* Mobile Input */}
                                        {contactMethod === 'mobile' && (
                                            <Form.Item
                                            label="Mobile Phone No."
                                            name="phone"
                                            rules={[
                                                { required: true, message: 'Please enter your mobile number' },
                                                { pattern: /^[0-9]+$/, message: 'Only numbers allowed' },
                                            ]}
                                            extra={<Text type="secondary">Please enter numbers only</Text>}
                                            >
                                            <Input
                                                placeholder="Enter your Mobile Number"
                                                onChange={(e) => {
                                                const numeric = e.target.value.replace(/\D/g, '');
                                                form.setFieldsValue({ mobile: numeric });
                                                }}
                                            />
                                            </Form.Item>
                                        )}

                                        <Divider />
                                        {/* Identification Type Radio Group */}
                                        <Form.Item label="Identification Type">
                                            <Radio.Group
                                                value={idType}
                                                onChange={(e) => {
                                                setIdType(e.target.value);
                                                form.setFieldsValue({
                                                    nric: '',
                                                    passport: '',
                                                    business_registration_no: ''
                                                });
                                            }}
                                            >
                                                <Radio value="nric">Malaysian NRIC No.</Radio>
                                                <Radio value="passport">Passport No.</Radio>
                                                <Radio value="business_registration_no">Business Registration No.</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        {(idType === 'nric' || idType === 'passport' || idType === 'business_registration_no') && (
                                            <Form.Item
                                                label={
                                                idType === 'nric'
                                                    ? 'Malaysian NRIC No.'
                                                    : idType === 'passport'
                                                    ? 'Passport No.'
                                                    : 'Business Registration No.'
                                                }
                                                name={idType}
                                                rules={[
                                                {
                                                    required: true,
                                                    message: `Please enter your ${
                                                    idType === 'nric'
                                                        ? 'Malaysian NRIC No.'
                                                        : idType === 'passport'
                                                        ? 'Passport No.'
                                                        : 'Business Registration No.'
                                                    }`
                                                },
                                                idType === 'nric'
                                                    ? {
                                                        pattern: /^[0-9]+$/,
                                                        message: 'Only numbers allowed (no dash or space)'
                                                    }
                                                    : {
                                                        pattern: /^[0-9a-zA-Z-]+$/,
                                                        message: 'Only alphanumeric characters and dashes allowed'
                                                    }
                                                ]}
                                            >
                                                <Input
                                                placeholder="Enter identification number"
                                                onChange={(e) => {
                                                    const raw = e.target.value;
                                                    let cleaned = raw;

                                                    if (idType === 'nric') {
                                                    cleaned = raw.replace(/[^0-9]/g, '');
                                                    } else {
                                                    cleaned = raw.replace(/[^0-9a-zA-Z-]/g, '');
                                                    }

                                                    form.setFieldsValue({ [idType]: cleaned });
                                                }}
                                                />
                                            </Form.Item>
                                        )}


                                        <Divider />
{/* 
                                        <div style={{ marginBottom: 16 }} className='d-flex justify-content-center align-items-center pt-3 pb-3'>
                                            <ReCAPTCHA
                                                sitekey={recaptcha_auth} // Replace with your actual key
                                                onChange={handleCaptchaChange}
                                                className="recaptcha-container" 
                                            />
                                        </div> */}

                                        {
                                            <>
                                            {/* TAC Code + Send Button */}
                                            <Form.Item label="TAC Code" required>
                                                <Input.Group compact>
                                                <Form.Item
                                                    name="code"
                                                    noStyle
                                                    rules={[{ required: true, message: 'Please enter the TAC code' }]}
                                                >
                                                    <Input style={{ width: '60%' }} maxLength={6}  addonBefore={tacChecksum}/>
                                                </Form.Item>
                                                <Button
                                                    style={{ width: '40%' }}
                                                    onClick={handleSendCode}
                                                    disabled={isSending}
                                                    className='btn-primary-custom  btn-tac btn-md'
                                                >
                                                    {cooldown > 0 ? `Resend in ${cooldown}s` : 'Send Code'}
                                                </Button>
                                                </Input.Group>
                                            </Form.Item>
                                        
                                        
                                        </>
                                        }

                                    

                                        <Divider />

                                        <div style={{ textAlign: 'center' }}>
                                            <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                                                Submit
                                            </Button>
                                        </div>
                                    </Form>
                                </>
                            )
                        }

                        {
                            step == 2 && 
                            (
                                <>
                                    <Divider />
                                    <Form form={form2} layout="vertical" style={{ marginTop: 24 }}  onFinish={onFinishForm2}>
                                        {/* Contact Method Radio Group */}
                                        <Form.Item label="Reset Method">
                                            <Radio.Group
                                                value={resetMethod}
                                                onChange={(e) => {
                                                    const method = e.target.value;
                                                    setResetMethod(method);
                                                    form.setFieldsValue({ password: '', unblock: '' }); // reset both fields
                                                }}
                                            >
                                                <Radio value="change_password">Reset Password</Radio>
                                                {config.enableChangeTradingPin === 1 && <Radio value="reset_trading_pin">Reset Trading PIN</Radio>}
                                                <Radio value="unblock_account">Unblock Account</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        {(resetMethod === 'change_password'||resetMethod === 'reset_trading_pin') && (
                                            <>
                                            <Form.Item
                                                label={resetMethod === 'reset_trading_pin' ? 'New Trading PIN' : 'New Password'}
                                                name="password"
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={passwordRules}
                                            >
                                                {renderSecretInput()}
                                            </Form.Item>

                                            {passwordRulesText}

                                            <Form.Item
                                                label={resetMethod === 'reset_trading_pin' ? 'Confirm New Trading PIN' : 'Confirm New Password'}
                                                name="confirmPassword"
                                                dependencies={['password']}
                                                rules={[
                                                { required: true, message: 'Please confirm the new value' },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Values do not match'));
                                                    },
                                                }),
                                                ]}
                                            >
                                                {renderSecretInput()}
                                            </Form.Item>
                                            </>
                                        )}


                                        <Divider />

                                        {recaptcha_auth && (
                                        <div style={{ marginBottom: 16 }} className='d-flex justify-content-center align-items-center pt-3 pb-3'>
                                            <ReCAPTCHA
                                                sitekey={recaptcha_auth} 
                                                onChange={handleCaptchaChange2}
                                                className="recaptcha-container"
                                            />
                                        </div>
                                        )}

                                        <Divider />

                                        <div style={{ textAlign: 'center' }}>
                                            <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                                                Submit
                                            </Button>
                                        </div>

                                    </Form>

                                </>
                            )
                        }

                     
                    {/* <Text type="secondary" style={{ display: 'block', marginTop: 16, textAlign: 'center' }}>
                        This page requires CAPTCHA Validation to proceed. Click <a href="#">here</a> to check if your browser is supported.
                    </Text> */}
    
                </div>
            </Card>
            </div>
        </>
    );
};

export default Index;
